export default function EmptyPage() {
  return <div>Empty Page</div>;
}
